module.exports = __webpack_public_path__ + "img/404-page-cropped.636aa0ad.jpg";